import i from "./highrise1309.mjs";
import m from "./highrise1337.mjs";
import a from "./highrise1532.mjs";
import s from "./highrise661.mjs";
function u(f, t, r) {
  if (!s(r))
    return !1;
  var e = typeof t;
  return (e == "number" ? m(r) && a(t, r.length) : e == "string" && t in r) ? i(r[t], f) : !1;
}
export {
  u as default
};
